import React from 'react';
import PropTypes from 'prop-types';

export function ListItem({
    style = {},
    onMouseEnter = () => {},
    onMouseLeave = () => {},
    onClick,
    children,
    className = '',
}) {
    return (
        <div
            onClick={onClick}
            className={`throne-list-item ${className}`}
            style={style}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {children}
        </div>
    );
}

ListItem.propTypes = {
    style: PropTypes.object,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};

export function Overlay({ children, className = 'throne-overlay' }) {
    return (
        <div id="throne-overlay" className={className}>
            {children}
        </div>
    );
}

Overlay.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
